import { render, staticRenderFns } from "./PsCardBlock.vue?vue&type=template&id=457cffc1&scoped=true&"
import script from "./PsCardBlock.vue?vue&type=script&lang=js&"
export * from "./PsCardBlock.vue?vue&type=script&lang=js&"
import style0 from "./PsCardBlock.vue?vue&type=style&index=0&id=457cffc1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457cffc1",
  null
  
)

component.options.__file = "PsCardBlock.vue"
export default component.exports